<template>
  <div>
    <span class="footer-scroll"></span>
  </div>
</template>

<script>
export default {

}
</script>

<style>
  .footer-scroll {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 5px;
    border:2px solid #f7fcfd;
    /* background-color: rgba(216, 16, 109,0.6); */
    position: absolute;
    left: 5%;
    top: -25px;
    z-index: 10;
    animation: scrollA infinite 20s linear alternate;
  }
  @keyframes scrollA {
    0% {left: 5%;transform: rotate(180deg);}
    10% {left: 5%;transform: rotate(270deg);}
    20% {left: 5%;transform: rotate(450deg);}
    25% {left: 10%;transform: rotate(540deg); border-color:#e5f5f9;}
    30% {left: 20%;transform: rotate(720deg); border-color: #ccece6;}
    35% {left: 30%;transform: rotate(900deg); border-color: #99d8c9;}
    40% {left: 40%;transform: rotate(1080deg); border-color: #66c2a4;}
    45% {left: 50%;transform: rotate(1260deg); border-color: #41ae76;}
    50% {left: 60%;transform: rotate(1440deg); border-color: #238b45;}
    55% {left: 70%;transform: rotate(1620deg); border-color: #006d2c;}
    60% {left: 80%;transform: rotate(1800deg); border-color: #00441b;}
    80% {left: 90%;transform: rotate(2610deg); }
    90% {left: 90%;transform: rotate(2340deg); }
    100% {left: 90%;transform: rotate(2520deg); }
  }
</style>